module.exports = __webpack_public_path__ + "static/media/codebot_flame.62ac94fd.svg";